import React, { createContext, useState, useContext } from "react";

const Context = createContext();

export const useLanguage = () => useContext(Context);

const STORAGE_KEY = "language";

// Luetaan aiemmin valittu kieli selaimen muistista (jos saatavilla)
const getInitialLanguage = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === "fi" || saved === "en") return saved;
  } catch (e) {
    // localStorage ei käytettävissä (esim. yksityinen selaus)
  }
  return "fi"; // Oletuskieli
};

export const Provider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      // ei haittaa, kieli pysyy valittuna tämän istunnon ajan
    }
  };

  return (
    <Context.Provider value={{ language, changeLanguage }}>
      {children}
    </Context.Provider>
  );
};
